const steps = [
	{
		id: '01',
		name: 'Stil auswählen',
		href: '#',
		status: 'current',
		step: 1,
		component: 'step-one',
	},
	{
		id: '02',
		name: 'Konfigurieren',
		href: '#',
		status: 'upcoming',
		step: 2,
		component: 'step-two',
	},
	{
		id: '03',
		name: 'Rechnungsdaten',
		href: '#',
		status: 'upcoming',
		step: 3,
		component: 'step-three',
	},
	{
		id: '04',
		name: 'Bestellung überprüfen',
		href: '#',
		status: 'upcoming',
		step: 4,
		component: 'step-four',
	},
	{
		id: '05',
		name: 'Bestellbestätigung',
		href: '#',
		status: 'upcoming',
		step: 5,
		component: 'step-five',
	},
]

export default steps
